<template>
  <div
    class="content"
    :class="{ active: selectedIndex == index }"
    @click="$emit('selectedValue', index)">
    <div class="drag-icon">
      <i class="icon icon-drag-handle"></i>
    </div>

    <div class="mwc-content">
      <FileUploadComponent fieldName="Name" :acceptType="fileType" :value.sync="fileName" @changeValue="changeValue" />
    </div>
  </div>
</template>

<script>
import TextComponent from '../base.component/TextComponent.vue';
import FileUploadComponent from '../base.component/FileUploadComponent.vue';
import { FILE_TYPES } from '@/constants/assets';

export default {
  components: {
    TextComponent,
    FileUploadComponent,
  },

  data() {
    return {
      fileName: '',
      fileType: FILE_TYPES.SVG
    };
  },

  watch: {
    item: function() {
      this.fileName = this.item;
    }
  },

  mounted() {
    this.fileName = this.item;
  },

  props: {
    item: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      required: true,
    },
    selectedIndex: {
      type: Number,
      default: -1,
    },
  },

  methods: {
    changeValue(name, file) {
      this.$emit('changeValue', name, file);
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';

.dark {
  margin-bottom: 0px !important;
}

.content {
  border: 1px solid @gray-42;
  padding: 0.5rem;
  width: 30vw;
  display: flex;
}

.active {
  border-color: @blue-43;
}

.mwc-content {
  width: -webkit-fill-available;
}

.drag-icon {
  padding-top: 1rem;
  padding-right: 0.5rem;
}
</style>